import MJSONDesigner from '@admin/components/mjson_designer'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

class Design extends React.Component {

  static propTypes = {
    module: PropTypes.object
  }

  render() {
    return <MJSONDesigner { ...this._getMJSONDesigner() } />
  }

  _getMJSONDesigner() {
    const { module } = this.props
    return {
      editable: true,
      endpoint: `/maha_modules/${module.id}`,
      root_route: `/platform/modules/${module.id}/design`,
      type: module.category.medium,
      versionable: false
    }
  }

}

const mapPropsToPanel = (props, context) => ({
  title: 't(Design)',
  component: <Design module={ props.module } />
})

export default Panel(null, mapPropsToPanel)
